import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import axios from "axios";
import { ajaxconfig } from "../ajaxconfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import cookie from "universal-cookie";
import QRCode from "react-qr-code";
import { TakeCbtPermitVerification, VerifyPublicGetCbtPassCode } from '../serverurl';

const CbtPassCodeVerification = () => {
    const [cbt_data, set_cbt_data] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isManualMode, setIsManualMode] = useState(false);
    const cookies = new cookie();
    const [cbt_pass_code_info, set_cbt_pass_code_info] = useState(cookies.get("name") || "");
    const auth_code = cookies.get("auto_login_code");

    const url_param = new URLSearchParams(window.location.search);
    const cbt_passcode = url_param.get("cbt_pass_code");
    const test_id_from_url = url_param.get("test_id");
    const [cbt_test_id_verify, set_cbt_test_id_verify] = useState(cookies.get("email") || "");
    const navigate = useNavigate();
    const cbtbarcode = "https://app.cbthost.com/qr_verification?cbt_pass_code=" + cbt_passcode;
    const config = ajaxconfig();
    
    // Check if test info was provided by instructor
    const isTestInfoProvided = cookies.get("name") !== undefined && cookies.get("name") !== null;
    // Check if test ID was provided by instructor
    const isTestIdProvided = test_id_from_url !== null;

    const toggleManualMode = () => setIsManualMode(!isManualMode);

    const redirectToApp = (cbt_passcode, test_id) => {
        // const appDeepLink = `cbthost://VerifyTask?cbt_pass_code=${cbt_passcode}&test_id=${test_id}&auth_code=${auth_code}`;
        const appDeepLink = `cbthost:://VerifyTask/?id=${auth_code}&cbt_passcode=${cbt_passcode}`;
        alert(appDeepLink);
        window.location.href = appDeepLink;
        setTimeout(() => {
            window.location.href = "https://cbthost.com/mobile_app";
        }, 1000);
    };

    const cbt_permit_code_manual_verification = (e) => {
        e.preventDefault();

        // Use manual values if in manual mode, otherwise instructor-provided values
        const finalTestId = isManualMode 
            ? cbt_test_id_verify 
            : (isTestIdProvided ? test_id_from_url : cbt_test_id_verify);

        const finalTestInfo = isManualMode 
            ? cbt_pass_code_info 
            : (isTestInfoProvided ? cookies.get("name") : cbt_pass_code_info);

        if (!finalTestId) {
            toast.error("Please provide a valid CBT Test ID");
            return;
        }

        setIsLoading(true);

        const payload = {
            cbt_test_id: finalTestId,
            cbt_test_id_info: finalTestInfo,
            cbt_pass_code: cbt_passcode
        };

        axios.post(TakeCbtPermitVerification, payload, config)
            .then((response) => {
                const { serverstatus, message, data } = response.data;

                toast.success(message);

                if (serverstatus === 200 && data) {
                    // Redirect user to CBT questions page
                    navigate(
                        `/participate/cbt_question?cbt_pass_code=${data.cbt_pass_code}&associated_user=${data.associated_user}`
                    );
                }
            })
            .catch((error) => {
                toast.error(error.response?.data?.message || "Verification failed");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleLogout = () => {
        // Clear all cookies
        const cookieNames = ['auto_login_code', 'auth_key', 'surname', 'name', 'email', 'authenticated', 'user_type'];
        cookieNames.forEach(cookieName => cookies.remove(cookieName));
        
        toast.success("Logged out successfully");
        setTimeout(() => {
            navigate('/login');
        }, 1000);
    };

    const handleDashboard = () => {
        navigate('/participate/dashboard');
    };

    useEffect(() => {
        const url = VerifyPublicGetCbtPassCode + cbt_passcode; 
        axios.get(url, config)
            .then((response) => {
                set_cbt_data(response.data.data);
                toast.success(response.data.message);
            })
            .catch((error) => {
                toast.error(error.message);
            });
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 pb-20">
            {/* Header */}
            <div className="bg-white shadow-sm border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center py-4">
                        <div className="flex items-center">
                            <i className="fas fa-graduation-cap text-2xl text-blue-600 mr-3"></i>
                            <h1 className="text-2xl font-bold text-gray-900">CBTHost</h1>
                        </div>
                        <div className="flex items-center space-x-4">
                            <span className="text-sm text-gray-600">Test Verification</span>
                            <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                                <span className="text-white text-sm font-bold">
                                    {(cookies.get('name') || 'P').charAt(0).toUpperCase()}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Test Information Card */}
                <div className="bg-white rounded-2xl shadow-lg overflow-hidden mb-8">
                    <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-6 py-6">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                            <div>
                                <h2 className="text-2xl font-bold text-white mb-2 flex items-center">
                                    <i className="fas fa-shield-alt mr-3"></i>
                                    Test Information
                                </h2>
                                <p className="text-blue-100">
                                    Verify your details before starting the test
                                </p>
                            </div>
                            <div className="mt-4 md:mt-0">
                                <span className={`inline-flex items-center px-4 py-2 rounded-xl text-sm font-semibold ${
                                    isManualMode 
                                        ? 'bg-purple-100 text-purple-800' 
                                        : 'bg-green-100 text-green-800'
                                }`}>
                                    <i className={`fas ${isManualMode ? 'fa-user-edit' : 'fa-robot'} mr-2`}></i>
                                    {isManualMode ? 'Manual Mode' : 'Auto Mode'}
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="p-6">
                        <div className="flex flex-col lg:flex-row gap-8">
                            {/* QR Code Section */}
                            <div className="w-full lg:w-2/5 flex flex-col items-center">
                                <div className="bg-gray-50 p-6 rounded-2xl shadow-inner border border-gray-200">
                                    <QRCode
                                        size={200}
                                        className="qr-code mx-auto"
                                        style={{ height: "auto", maxWidth: "100%" }}
                                        value={cbtbarcode}
                                        viewBox={`0 0 200 200`}
                                    />
                                </div>
                                <p className="text-gray-500 mt-4 text-sm text-center">
                                    <i className="fas fa-qrcode mr-2"></i>
                                    Scan QR code to share this test
                                </p>
                                
                                {/* Mobile App Button */}
                                <button 
                                    onClick={() => redirectToApp(cbt_passcode, isTestIdProvided && !isManualMode ? test_id_from_url : cbt_test_id_verify)}
                                    className="mt-4 w-full inline-flex items-center justify-center px-4 py-3 border border-transparent text-sm font-medium rounded-xl shadow-sm text-white bg-gradient-to-r from-indigo-600 to-purple-700 hover:from-indigo-700 hover:to-purple-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 transform hover:-translate-y-0.5"
                                >
                                    <i className="fas fa-mobile-alt mr-2"></i>
                                    Open in Mobile App
                                </button>
                            </div>
                            
                            {/* Test Details */}
                            <div className="w-full lg:w-3/5">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {/* Test Details Card */}
                                    <div className="bg-blue-50 rounded-2xl p-5 border border-blue-200">
                                        <h3 className="text-lg font-semibold text-blue-800 mb-3 flex items-center">
                                            <i className="fas fa-info-circle mr-2"></i>
                                            Test Details
                                        </h3>
                                        <div className="space-y-3">
                                            <div>
                                                <p className="text-sm text-blue-600 font-medium">Pass Code</p>
                                                <p className="text-lg font-bold text-blue-900 font-mono">{cbt_passcode}</p>
                                            </div>
                                            <div>
                                                <p className="text-sm text-blue-600 font-medium">Description</p>
                                                <p className="text-base text-blue-900">{cbt_data.cbt_name || 'N/A'}</p>
                                            </div>
                                            <div>
                                                <p className="text-sm text-blue-600 font-medium">Status</p>
                                                <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                                                    cbt_data.cbt_status === 'published' 
                                                        ? 'bg-green-100 text-green-800' 
                                                        : 'bg-red-100 text-red-800'
                                                }`}>
                                                    <i className={`fas ${cbt_data.cbt_status === 'published' ? 'fa-check-circle' : 'fa-times-circle'} mr-1`}></i>
                                                    {cbt_data.cbt_status || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Test Statistics Card */}
                                    <div className="bg-green-50 rounded-2xl p-5 border border-green-200">
                                        <h3 className="text-lg font-semibold text-green-800 mb-3 flex items-center">
                                            <i className="fas fa-chart-bar mr-2"></i>
                                            Test Statistics
                                        </h3>
                                        <div className="space-y-3">
                                            {/* <div>
                                                <p className="text-sm text-green-600 font-medium">Total Questions</p>
                                                <div className="flex items-center">
                                                    <span className="text-2xl font-bold text-green-900 mr-2">{cbt_data.question_count || '0'}</span>
                                                    <i className="fas fa-question-circle text-green-500"></i>
                                                </div>
                                            </div> */}
                                            <div>
                                                <p className="text-sm text-green-600 font-medium">Test Duration</p>
                                                <p className="text-base text-green-900">{cbt_data.duration || 'N/A'} minutes</p>
                                            </div>
                                            {/* <div>
                                                <p className="text-sm text-green-600 font-medium">Difficulty</p>
                                                <p className="text-base text-green-900 capitalize">{cbt_data.difficulty || 'N/A'}</p>
                                            </div> */}
                                        </div>
                                    </div>

                                    {/* User Information Card */}
                                    <div className="bg-purple-50 rounded-2xl p-5 border border-purple-200 md:col-span-2">
                                        <h3 className="text-lg font-semibold text-purple-800 mb-3 flex items-center">
                                            <i className="fas fa-user-check mr-2"></i>
                                            Your Information
                                        </h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <p className="text-sm text-purple-600 font-medium">Test ID</p>
                                                <p className="text-base font-medium text-purple-900">
                                                    {isTestIdProvided && !isManualMode ? test_id_from_url : cbt_test_id_verify || 'Not provided'}
                                                </p>
                                            </div>
                                            <div>
                                                <p className="text-sm text-purple-600 font-medium">Test Information</p>
                                                <p className="text-base font-medium text-purple-900">
                                                    {isTestInfoProvided && !isManualMode ? cookies.get("name") : cbt_pass_code_info || 'Not provided'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Verification Form Card */}
                <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                    <div className="bg-gradient-to-r from-cyan-600 to-teal-700 px-6 py-6">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                            <h2 className="text-2xl font-bold text-white flex items-center mb-4 md:mb-0">
                                <i className="fas fa-file-alt mr-3"></i>
                                Test Verification
                            </h2>
                            <div className="flex space-x-3">
                                {/* Mode Toggle Button */}
                                <button
                                    type="button"
                                    onClick={toggleManualMode}
                                    className={`px-5 py-2 rounded-xl font-semibold text-sm transition-all duration-300 transform hover:-translate-y-0.5 ${
                                        isManualMode
                                            ? 'bg-purple-600 hover:bg-purple-700 text-white shadow-lg'
                                            : 'bg-green-600 hover:bg-green-700 text-white shadow-lg'
                                    }`}
                                >
                                    {isManualMode ? (
                                        <span className="flex items-center">
                                            <i className="fas fa-toggle-on mr-2"></i>
                                            Manual Mode
                                        </span>
                                    ) : (
                                        <span className="flex items-center">
                                            <i className="fas fa-toggle-off mr-2"></i>
                                            Auto Mode
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div className="p-6">
                        <div className="max-w-2xl mx-auto">
                            <form onSubmit={cbt_permit_code_manual_verification}>
                                <div className="space-y-6">
                                    {/* Show Test ID field if in manual mode OR if test ID wasn't provided */}
                                    {(isManualMode || !isTestIdProvided) && (
                                        <div className="group">
                                            <label className="block text-sm font-semibold text-gray-700 mb-3">
                                                <i className="fas fa-key mr-2 text-blue-500"></i>
                                                Test ID
                                            </label>
                                            <div className="relative">
                                                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                                    <i className="fas fa-id-card text-gray-400 group-hover:text-blue-500 transition-colors"></i>
                                                </div>
                                                <input
                                                    value={cbt_test_id_verify}
                                                    onChange={(e) => set_cbt_test_id_verify(e.target.value)}
                                                    className="block w-full pl-12 pr-4 py-4 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-blue-300"
                                                    placeholder="Enter your Test ID"
                                                    required={isManualMode || !isTestIdProvided}
                                                />
                                            </div>
                                            <p className="text-xs text-gray-500 mt-2 ml-1">
                                                <i className="fas fa-info-circle mr-1"></i>
                                                Your unique identifier for this test
                                            </p>
                                        </div>
                                    )}
                                    
                                    {/* Show Test Information field if in manual mode OR if test info wasn't provided */}
                                    {(isManualMode || !isTestInfoProvided) && (
                                        <div className="group">
                                            <label className="block text-sm font-semibold text-gray-700 mb-3">
                                                <i className="fas fa-user mr-2 text-cyan-500"></i>
                                                Test Information
                                            </label>
                                            <div className="relative">
                                                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                                    <i className="fas fa-info-circle text-gray-400 group-hover:text-cyan-500 transition-colors"></i>
                                                </div>
                                                <input
                                                    value={cbt_pass_code_info}
                                                    onChange={(e) => set_cbt_pass_code_info(e.target.value)}
                                                    className="block w-full pl-12 pr-4 py-4 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-all duration-200 group-hover:border-cyan-300"
                                                    placeholder="Enter your full name or information"
                                                    required={isManualMode || !isTestInfoProvided}
                                                />
                                            </div>
                                            <p className="text-xs text-gray-500 mt-2 ml-1">
                                                <i className="fas fa-info-circle mr-1"></i>
                                                Your name or additional test information
                                            </p>
                                        </div>
                                    )}
                                    
                                    {/* Start Test Button */}
                                    <div className="pt-4">
                                        <button
                                            type="submit"
                                            disabled={isLoading}
                                            className={`w-full py-4 px-6 rounded-xl text-white font-bold shadow-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl ${
                                                isLoading
                                                    ? 'bg-gray-400 cursor-not-allowed'
                                                    : 'bg-gradient-to-r from-cyan-600 to-teal-700 hover:from-cyan-700 hover:to-teal-800'
                                            }`}
                                        >
                                            {isLoading ? (
                                                <div className="flex items-center justify-center">
                                                    <svg className="animate-spin -ml-1 mr-3 h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                    </svg>
                                                    <span className="text-lg">Verifying Your Information...</span>
                                                </div>
                                            ) : (
                                                <div className="flex items-center justify-center text-lg">
                                                    <i className="fas fa-play-circle mr-3 text-xl"></i>
                                                    Start Test Now
                                                </div>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Navigation */}
            <div className="fixed bottom-0 left-0 right-0 bg-white shadow-2xl border-t border-gray-200">
                <div className="max-w-md mx-auto">
                    <div className="flex justify-around items-center py-3">
                        <button
                            onClick={handleDashboard}
                            className="flex flex-col items-center px-4 py-2 rounded-2xl text-blue-600 hover:bg-blue-50 transition-all duration-200 transform hover:-translate-y-0.5"
                        >
                            <i className="fas fa-home text-xl mb-1"></i>
                            <span className="text-xs font-medium">Dashboard</span>
                        </button>


                        {/* <button
                            onClick={handleProfile}
                            className="flex flex-col items-center px-4 py-2 rounded-2xl text-blue-600 hover:bg-blue-50 transition-all duration-200 transform hover:-translate-y-0.5"
                        >
                            <i className="fas fa-home text-xl mb-1"></i>
                            <span className="text-xs font-medium">Profile</span>
                        </button> */}

                        
                        <button
                            onClick={handleLogout}
                            className="flex flex-col items-center px-4 py-2 rounded-2xl text-gray-500 hover:text-red-600 hover:bg-red-50 transition-all duration-200 transform hover:-translate-y-0.5"
                        >
                            <i className="fas fa-sign-out-alt text-xl mb-1"></i>
                            <span className="text-xs font-medium">Logout</span>
                        </button>
                    </div>
                </div>
            </div>

            <ToastContainer 
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                toastClassName="rounded-xl"
            />

            <style jsx>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes scaleIn {
                    from { 
                        opacity: 0;
                        transform: scale(0.9) translateY(-10px);
                    }
                    to { 
                        opacity: 1;
                        transform: scale(1) translateY(0);
                    }
                }
                .animate-fade-in {
                    animation: fadeIn 0.3s ease-out;
                }
                .animate-scale-in {
                    animation: scaleIn 0.3s ease-out;
                }
            `}</style>
        </div>
    );
}

export { CbtPassCodeVerification };